import { WebappEnv } from '@/entities/webapp-env';
import { env } from '@/env';
import type { LookerEnv } from '@/types/looker-env';
import { UnreachableCaseError } from '@/utils/errors/unreachable-case-error';

import { useMe } from '../use-me';

import { useLookerEnv } from './use-looker-env';

export function useLookerModelId() {
  const me = useMe();
  const [lookerEnv] = useLookerEnv();

  return lookerModelId(me.tenant, lookerEnv);
}

function lookerModelId(customerName: string, lookerEnv: LookerEnv): string {
  const prefix = prefixFromWebappEnv();

  return `${prefix}platform_${customerName}_${lookerEnv}`;
}

/**
 * The webapp can be read from other read-only looker project,
 * in this case we want to prefix the modelId
 */
function prefixFromWebappEnv(): string {
  switch (env.VITE_WEBAPP_ENV) {
    case WebappEnv.STAGING: {
      return 'staging_';
    }
    case WebappEnv.SANDBOX: {
      return 'sandbox_';
    }
    case WebappEnv.PRODUCTION:
    case WebappEnv.LOCAL: {
      return '';
    }
    default: {
      throw new UnreachableCaseError(env.VITE_WEBAPP_ENV);
    }
  }
}
